import { render } from "./HowtoSimp.vue?vue&type=template&id=1c78b381"
import script from "./HowtoSimp.vue?vue&type=script&lang=js"
export * from "./HowtoSimp.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__